
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import pc from './pc/ayuda.vue';
    import movil from './pc/ayuda.vue';

    @Component( {
        name: "Componente",
        props: {},
        components: { pc, movil }
    } )
    export default class Componente extends Vue
    {
        created()
        {
        }


    }
